module.exports = __webpack_public_path__ + "static/img/image1.fe81047d.png";